"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toastr = require("toastr");

var _toastr2 = _interopRequireDefault(_toastr);

require("toastr/build/toastr.min.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var toastrPlugin = {};

toastrPlugin.install = function (Vue) {
  _toastr2.default.options.positionClass = "toast-top-center";
  _toastr2.default.options.showEasing = "swing";
  _toastr2.default.options.hideEasing = "linear";
  _toastr2.default.options.showMethod = "fadeIn";
  _toastr2.default.options.hideMethod = "fadeOut";
  Vue.prototype.$toastr = _toastr2.default;
};

exports.default = toastrPlugin;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/plugins/Toastr.js
// module id = 8DkO
// module chunks = 0 1